import React from 'react';
import { I18n } from 'react-redux-i18n';

import { I18N_BASE } from '../../constants';
import { NOTES_MAX_LENGTH } from '../../models';
import styles from './modals.module.css';

export interface NotesFieldProps {
  value: string;
  onChange: (next: string) => void;
  maxLength?: number;
  placeholderKey?: string;
  disabled?: boolean;
  testId?: string;
}

export function NotesField({
  value,
  onChange,
  maxLength = NOTES_MAX_LENGTH,
  placeholderKey = `${I18N_BASE}.blockModal.notes.placeholder`,
  disabled = false,
  testId,
}: NotesFieldProps): React.ReactElement {
  const over = value.length > maxLength;
  return (
    <div className={styles.notesWrap} data-testid={testId}>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={I18n.t(placeholderKey)}
        disabled={disabled}
        data-testid={testId ? `${testId}-textarea` : undefined}
        rows={3}
        // Native hard-stop at the same limit the counter advertises. The
        // over-limit class on the counter stays as a belt-and-braces signal
        // for the rare paste-over case the browser still allows.
        maxLength={maxLength}
      />
      <span
        className={`${styles.notesCounter} ${over ? styles.notesCounterOver : ''}`}
        data-testid={testId ? `${testId}-counter` : undefined}
      >
        {value.length}/{maxLength}
      </span>
    </div>
  );
}

export default NotesField;
